import React, { useEffect, useState } from "react";
import "./HealthInsuranceTable.css";
import axios from "axios";
import { Table, Spin, Form, Input, Popconfirm, Typography, Button } from "antd";
import { ErrorMessage, SuccessMessage, InfoMessage } from "../../Utils/Utils";
import { BaseUrl, JsonConfig, FormConfig, UserName, jwtToken } from "../../Repository/BaseRepository";
import { callGetGridData, prepareCSV } from "../../Repository/HealthInsuranceRepository";
import { EditFilled, CheckCircleFilled, CloseCircleFilled, SearchOutlined, DeleteOutlined } from "@ant-design/icons";

const HealthInsuranceTable = ({ grid, tSpin, sendDataToParent }) => {
    const propsData = grid;
    const [gridData, setGridData] = useState([]);
    const tableSpin = tSpin;
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const [rowData, setRowData] = useState([])
    const [prepareCSVSpin, setPrepareCSVSpin] = useState(false)
    const [searchRow, setSearchRow] = useState("")
    const [EditingRecord, setEditingRecord] = useState(null);
    const IsRecordInEditingState = (Id) => Id === EditingRecord;
    const date = new Date();
    var todayDate = parseInt(date.getMonth() + 1) + '/' + parseInt(date.getDate()) + '/' + parseInt(date.getFullYear());
    useEffect(() => {
        setGridData(propsData)
    }, [propsData])
    const isEditing = (record) => record.Id === editingKey;
    const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };
    const filterProps = () => ({
        filteredValue: [searchRow],
        onFilter: (value, record) => {
            return (
                String(record.File)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.SSN)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.Full_Name).toLowerCase().includes(value.toLowerCase())
            );
        },
    });
    const allDates = Array.from(
        new Set(gridData.flatMap(item => item.NewEmployeeData.map(data => data.date)))
    );
    const sortedDates = allDates.sort((a, b) => new Date(a) - new Date(b));
    const columns = [
        {
            title: 'Division',
            dataIndex: 'Division',
            key: 'Division',
            width: 100,
            editable: true
        },
        {
            title: 'Corp W2',
            dataIndex: 'Corp_W2',
            key: 'Corp_W2',
            width: 80,
            editable: true
        },
        {
            title: 'SSN',
            dataIndex: 'SSN',
            key: 'SSN',
            width: 150,
            editable: true,
            render: (text, record) => (
                <EditableCell
                    dataIndex={`File_${record.SSN}`}
                    editing={IsRecordInEditingState(record.SSN)}
                >
                    {IsRecordInEditingState(record.SSN)
                        ? text || ""
                        : text
                            ? "*******"
                            : ""}
                </EditableCell>
            ),
        },
        {
            title: 'File',
            dataIndex: 'File',
            key: 'File',
            width: 150,
            editable: true,
            ...filterProps(),
            render: (text, record) => (
                <EditableCell
                    dataIndex={`File_${record.File}`}
                    editing={IsRecordInEditingState(record.File)}
                >
                    {IsRecordInEditingState(record.File)
                        ? text || ""
                        : text
                            ? "*******"
                            : ""}
                </EditableCell>
            ),
        },
        {
            title: 'Full Name',
            dataIndex: 'Full_Name',
            key: 'Full_Name',
            width: 100,
            editable: true
        },
        {
            title: 'Frequency',
            dataIndex: 'Freq',
            key: 'Freq',
            width: 90,
            editable: true
        },
        {
            title: 'Status',
            dataIndex: 'Status',
            key: 'Status',
            editable: true
        },
        {
            title: 'Employee Status',
            dataIndex: 'Employee_Status',
            key: 'Employee_Status',
            width: 130,
            editable: true
        },
        {
            title: 'Term Date',
            dataIndex: 'TermDate',
            key: 'TermDate',
            width: 100,
            editable: true
        },
        {
            title: 'Pay Cycle',
            dataIndex: 'Pay_Cycle',
            key: 'Pay_Cycle',
            width: 90,
            editable: true
        },
        {
            title: 'Plan Type',
            dataIndex: 'Plan_Type',
            key: 'Plan_Type',
            width: 140,
            editable: true
        },
        {
            title: 'Plan Admin Name',
            dataIndex: 'Plan_Admin_Name',
            key: 'Plan_Admin_Name',
            editable: true
        },
        {
            title: 'Code',
            dataIndex: 'Code',
            key: 'Code',
            width: 60,
            editable: true
        },
        {
            title: 'ER Cost',
            dataIndex: 'ER_Cost',
            key: 'ER_Cost',
            width: 100,
            editable: true
        },
        {
            title: 'Effective Date',
            dataIndex: 'Effective_Date',
            key: 'Effective_Date',
            width: 120,
            editable: true
        },
        {
            title: 'EE Pre-Tax',
            dataIndex: 'EE_PreTax',
            key: 'EE_PreTax',
            width: 90,
            editable: true
        },
        {
            title: 'EE Post-Tax',
            dataIndex: 'EE_PostTax',
            key: 'EE_PostTax',
            width: 100,
            editable: true
        },
        {
            title: 'Payroll Code',
            dataIndex: 'Payroll_Code',
            key: 'Payroll_Code',
            width: 110,
            editable: true
        },
        {
            title: 'Total Cost',
            dataIndex: 'Total_Cost',
            key: 'Total_Cost',
            width: 90,
            editable: true
        },
        {
            title: 'Per Day',
            dataIndex: 'Per_Day',
            key: 'Per_Day',
            width: 90,
            editable: true
        },
        ...sortedDates.map(date => ({
            title: date,
            dataIndex: date,
            key: date,
            width: 180,
            editable: true,
            render: (text, record) => {
                const matchingData = record.NewEmployeeData.find(data => data.date === date);
                return matchingData ? matchingData.value : null;
            },
            onCell: record => ({
                record,
                editable: true,
                dataIndex: date,
                title: date,
            }),
        })),

        {
            title: 'Action',
            dataIndex: 'operation',
            width: 100,
            fixed: "right",
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Popconfirm title="Sure to save?" onConfirm={() => editHRTableRowData(record)} onCancel={cancel}>
                            <Typography.Link style={{ marginRight: 8, }} >
                                <CheckCircleFilled style={{ fontSize: 19, color: 'green' }} className="save-cancel-icon" />
                            </Typography.Link>
                        </Popconfirm>
                        <Typography.Link onClick={() => cancel()}>
                            <CloseCircleFilled style={{ fontSize: 19, color: 'red' }} className="save-cancel-icon" />
                        </Typography.Link>
                    </span>
                ) : (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Typography.Link onClick={() => edit(record)}>
                            <div>
                                <EditFilled style={{ fontSize: 18, color: '#003A8C' }} />
                            </div>
                        </Typography.Link>
                        <Popconfirm
                            title="Are you sure want to delete?"
                            onConfirm={() => deleteGridRow(record.Id, record.Plan_Type)}
                            okText="Yes"
                            cancelText="No">
                            <DeleteOutlined style={{ fontSize: 18, marginLeft: 10, color: 'red', paddingBottom: 3 }} />
                        </Popconfirm>
                    </div>
                );
            },
        },
    ]
    const deleteGridRow = async (id, plan) => {
        try {
            let url = `${BaseUrl}HealthInsurance/DeleteGridData?plantype=${plan}&id=${id}`;
            const response = await axios.delete(url, JsonConfig)
            if (response.data.statusCode === 200) {
                const filteredData = gridData.filter((item) => item.Id !== id);
                setGridData(filteredData)
                sendDataToParent(filteredData)
                SuccessMessage(response.data.message)
            }
            else { ErrorMessage(response.data.message); }
        }
        catch {
            ErrorMessage("Cannot able to delete");
        }
    }
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    const compareObjects = (obj1, obj2) => {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) {
            return false;
        }

        for (let key of keys1) {
            const val1 = obj1[key];
            const val2 = obj2[key];

            if (Array.isArray(val1) && Array.isArray(val2)) {
                if (!compareArrays(val1, val2)) {
                    return false;
                }
            } else if (val1 !== val2) {
                return false;
            }
        }

        return true;
    };

    const compareArrays = (arr1, arr2) => {
        if (arr1.length !== arr2.length) {
            return false;
        }

        for (let i = 0; i < arr1.length; i++) {
            if (!compareObjects(arr1[i], arr2[i])) {
                return false;
            }
        }

        return true;
    };
    const editHRTableRowData = async (props) => {
        try {
            const originalData = await form.getFieldValue();
            const transformData = (originalData, sortedDates) => {
                const newEmployeeData = sortedDates.map(date => ({
                    date,
                    value: originalData[date] || '',
                }));
                const transformedData = {
                    ...originalData,
                    NewEmployeeData: newEmployeeData,
                };
                return transformedData;
            };
            const currentRowData = transformData(originalData, sortedDates);
            const result = compareObjects(currentRowData, rowData);
            if(result === false){
                const matchedKeys = Object.keys(currentRowData).filter(date => sortedDates.includes(date));
                const sortedDateArray = matchedKeys.sort((a, b) => new Date(a) - new Date(b));
                const extractedData = sortedDateArray.reduce((acc, date) => {
                    if (currentRowData.hasOwnProperty(date)) {
                        acc[date] = currentRowData[date];
                    }
                    return acc;
                }, {});
                const formattedData = {};
                for (const key in extractedData) {
                    formattedData[String(key)] = extractedData[key];
                }
                const jsonString = JSON.stringify(extractedData);
                const data = {
                    "id": currentRowData.Id,
                    "division": currentRowData.Division,
                    "corp_W2": currentRowData.Corp_W2,
                    "ssn": currentRowData.SSN,
                    "file": currentRowData.File,
                    "full_Name": currentRowData.Full_Name,
                    "freq": currentRowData.Freq,
                    "status": currentRowData.Status,
                    "employee_Status": currentRowData.Employee_Status,
                    "termDate": currentRowData.TermDate,
                    "plan_Type": currentRowData.Plan_Type,
                    "plan_Admin_Name": currentRowData.Plan_Admin_Name,
                    "code": currentRowData.Code,
                    "eR_Cost": currentRowData.ER_Cost,
                    "effective_Date": currentRowData.Effective_Date,
                    "pay_Cycle": currentRowData.Pay_Cycle,
                    "eE_PreTax": currentRowData.EE_PreTax,
                    "eE_PostTax": currentRowData.EE_PostTax,
                    "payroll_Code": currentRowData.Payroll_Code,
                    "total_Cost": currentRowData.Total_Cost,
                    "per_Day": currentRowData.Per_Day,
                    "upload_Date": currentRowData.upload_Date,
                    "newEmployeeData": jsonString,
                }
                let url = `${BaseUrl}HealthInsurance/updatingGridData`;
                const response = await axios.put(url, data, JsonConfig)
                if (response.data.statusCode === 200) {
                    const res = await callGetGridData()
                    if (res !== null && res.length > 0) {
                        setGridData(res)
                        sendDataToParent(res)
                        SuccessMessage(response.data.message)
                    }
                }
                else if (response.data.statusCode === 500) {
                    InfoMessage(response.data.message)
                }
                setEditingKey("");
            }
            else{
                InfoMessage("No changes made. Edit and try again.")
            }
        }
        catch {
            ErrorMessage("Can't able update data")
            setEditingKey("");
        }

    }
    const cancel = () => {
        setEditingKey('');
    };
    const edit = (record) => {
        const transformedData = {
            ...record,
            ...record.NewEmployeeData.reduce((acc, entry) => {
                acc[entry.date] = entry.value;
                return acc;
            }, {})
        };
        setRowData(transformedData)
        form.resetFields();
        form.setFieldsValue({
            ...transformedData,
        });
        setEditingKey(record.Id);
    };
    const callPrepareCSV = async () => {
        setPrepareCSVSpin(true)
        const resp = await prepareCSV(gridData)
        if (resp === "downloaded") {
            SuccessMessage("Downloaded successfully !!")
        }
        setPrepareCSVSpin(false)
    }

    return (<>
        <div className={gridData.length > 0 ? "hrtable-row" : "hrtable-row-minimized"}>
            <div className="search-row">
                <Input
                    placeholder="Search File Number \ SSN \ Name"
                    className="hr-searchrow"
                    style={{ borderColor: "#002766", color: "#F4F9FF" }}
                    onChange={(e) => setSearchRow(e.target.value)}
                    allowClear
                    suffix={
                        <SearchOutlined
                            style={{ color: "#002766", justifyContent: "space-between" }}
                        />
                    }
                />
            </div>
            <div>
                {
                    tableSpin ? <Spin tip="Loading..."> <Form form={form} component={false}>
                        <Table
                            className="hrfile-table"
                            rowClassName="editable-row"
                            columns={mergedColumns} dataSource={gridData} bordered
                            components={{ body: { cell: EditableCell, }, }} scroll={{ x: 400, y: 400 }}
                        // pagination={{ pageSize, position: ['bottomCenter'] }}
                        ></Table>
                    </Form> </Spin> : gridData.length > 0 ? <Form form={form} component={false}>
                        <Table className="hrfile-table"
                            rowClassName="editable-row"
                            columns={mergedColumns} dataSource={gridData} bordered
                            components={{ body: { cell: EditableCell, }, }} scroll={{ x: "max-content", y: 400 }}
                        // pagination={{ pageSize, position: ['bottomCenter'] }}
                        ></Table>
                    </Form> : <Form form={form} component={false}>
                        <Table className="hrfile-table"
                            rowClassName="editable-row"
                            columns={mergedColumns} dataSource={gridData} bordered
                            components={{ body: { cell: EditableCell, }, }} scroll={{ x: 400, y: 400 }}
                        // pagination={{ pageSize, position: ['bottomCenter'] }}
                        ></Table>
                    </Form>
                }
            </div>
            <div className={gridData.length > 0 ? "validate-prepare-row" : "validate-prepare-row-minimized"}>
                <Button className="prepare-csv-button" onClick={callPrepareCSV} loading={prepareCSVSpin}>Prepare CSV</Button>
            </div>

        </div>
    </>)

}
export default HealthInsuranceTable;